<div class="wrapper p-2">
    <div class="info-header">
        <i class="fas fa-info-circle mr-1"></i>
        <span class="info-font mr-1">Extensões permitidas:</span>

        @for (extension of $allowedExtensions(); track extension) {
            <span class="text-highlight info-font text-uppercase heavy ml-1">{{extension}}</span>
        }
    </div>

    <div class="file-container p-2 mt-1">
        <label class="m-0 py-1 px-2">
            <i class="fas fa-folder-open mr-1"></i>
            <span>Escolher arquivo</span>

            @if ($drawInput()) {
                <input type="file" [accept]="$mimeType()" [disabled]="$disabled()" (change)="changeFile($event)">
            }
        </label>

        @if ($fileName() != null) {
            <span class="ml-2 info-font file-name">{{$fileName()}}</span>

            @if (!$disabled()) {
                <i class="fas fa-times-circle ml-2" matTooltip="Remover arquivo" (click)="removeFile($event)" (keyDown)="removeFile($event)"></i>
            }
        } @else {
            <span class="ml-2 info-font font-italic">Nenhum arquivo selecionado</span>
        }
    </div>
</div>
